/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReviewIndexRouteImport } from './routes/review/index'
import { Route as ProcessingIndexRouteImport } from './routes/processing/index'
import { Route as PostIndexRouteImport } from './routes/post/index'
import { Route as PaymentIndexRouteImport } from './routes/payment/index'
import { Route as IntakeIndexRouteImport } from './routes/intake/index'
import { Route as EvidenceIndexRouteImport } from './routes/evidence/index'
import { Route as ReviewCaseIdRouteImport } from './routes/review/$caseId'
import { Route as ProcessingCaseIdRouteImport } from './routes/processing/$caseId'
import { Route as PostCaseIdRouteImport } from './routes/post/$caseId'
import { Route as PaymentCaseIdRouteImport } from './routes/payment/$caseId'
import { Route as IntakeCaseIdRouteImport } from './routes/intake/$caseId'
import { Route as EvidenceCaseIdRouteImport } from './routes/evidence/$caseId'
import { Route as AdminInfraRouteImport } from './routes/admin/infra'
import { Route as AdminControlRouteImport } from './routes/admin/control'
import { Route as AdminAiopsRouteImport } from './routes/admin/aiops'

const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewIndexRoute = ReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessingIndexRoute = ProcessingIndexRouteImport.update({
  id: '/processing/',
  path: '/processing/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostIndexRoute = PostIndexRouteImport.update({
  id: '/post/',
  path: '/post/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentIndexRoute = PaymentIndexRouteImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeIndexRoute = IntakeIndexRouteImport.update({
  id: '/intake/',
  path: '/intake/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvidenceIndexRoute = EvidenceIndexRouteImport.update({
  id: '/evidence/',
  path: '/evidence/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewCaseIdRoute = ReviewCaseIdRouteImport.update({
  id: '/review/$caseId',
  path: '/review/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessingCaseIdRoute = ProcessingCaseIdRouteImport.update({
  id: '/processing/$caseId',
  path: '/processing/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const PostCaseIdRoute = PostCaseIdRouteImport.update({
  id: '/post/$caseId',
  path: '/post/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentCaseIdRoute = PaymentCaseIdRouteImport.update({
  id: '/payment/$caseId',
  path: '/payment/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeCaseIdRoute = IntakeCaseIdRouteImport.update({
  id: '/intake/$caseId',
  path: '/intake/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const EvidenceCaseIdRoute = EvidenceCaseIdRouteImport.update({
  id: '/evidence/$caseId',
  path: '/evidence/$caseId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInfraRoute = AdminInfraRouteImport.update({
  id: '/admin/infra',
  path: '/admin/infra',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminControlRoute = AdminControlRouteImport.update({
  id: '/admin/control',
  path: '/admin/control',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiopsRoute = AdminAiopsRouteImport.update({
  id: '/admin/aiops',
  path: '/admin/aiops',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/admin/aiops': typeof AdminAiopsRoute
  '/admin/control': typeof AdminControlRoute
  '/admin/infra': typeof AdminInfraRoute
  '/evidence/$caseId': typeof EvidenceCaseIdRoute
  '/intake/$caseId': typeof IntakeCaseIdRoute
  '/payment/$caseId': typeof PaymentCaseIdRoute
  '/post/$caseId': typeof PostCaseIdRoute
  '/processing/$caseId': typeof ProcessingCaseIdRoute
  '/review/$caseId': typeof ReviewCaseIdRoute
  '/evidence/': typeof EvidenceIndexRoute
  '/intake/': typeof IntakeIndexRoute
  '/payment/': typeof PaymentIndexRoute
  '/post/': typeof PostIndexRoute
  '/processing/': typeof ProcessingIndexRoute
  '/review/': typeof ReviewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/admin/aiops': typeof AdminAiopsRoute
  '/admin/control': typeof AdminControlRoute
  '/admin/infra': typeof AdminInfraRoute
  '/evidence/$caseId': typeof EvidenceCaseIdRoute
  '/intake/$caseId': typeof IntakeCaseIdRoute
  '/payment/$caseId': typeof PaymentCaseIdRoute
  '/post/$caseId': typeof PostCaseIdRoute
  '/processing/$caseId': typeof ProcessingCaseIdRoute
  '/review/$caseId': typeof ReviewCaseIdRoute
  '/evidence': typeof EvidenceIndexRoute
  '/intake': typeof IntakeIndexRoute
  '/payment': typeof PaymentIndexRoute
  '/post': typeof PostIndexRoute
  '/processing': typeof ProcessingIndexRoute
  '/review': typeof ReviewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/admin/aiops': typeof AdminAiopsRoute
  '/admin/control': typeof AdminControlRoute
  '/admin/infra': typeof AdminInfraRoute
  '/evidence/$caseId': typeof EvidenceCaseIdRoute
  '/intake/$caseId': typeof IntakeCaseIdRoute
  '/payment/$caseId': typeof PaymentCaseIdRoute
  '/post/$caseId': typeof PostCaseIdRoute
  '/processing/$caseId': typeof ProcessingCaseIdRoute
  '/review/$caseId': typeof ReviewCaseIdRoute
  '/evidence/': typeof EvidenceIndexRoute
  '/intake/': typeof IntakeIndexRoute
  '/payment/': typeof PaymentIndexRoute
  '/post/': typeof PostIndexRoute
  '/processing/': typeof ProcessingIndexRoute
  '/review/': typeof ReviewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/admin/aiops'
    | '/admin/control'
    | '/admin/infra'
    | '/evidence/$caseId'
    | '/intake/$caseId'
    | '/payment/$caseId'
    | '/post/$caseId'
    | '/processing/$caseId'
    | '/review/$caseId'
    | '/evidence/'
    | '/intake/'
    | '/payment/'
    | '/post/'
    | '/processing/'
    | '/review/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/admin/aiops'
    | '/admin/control'
    | '/admin/infra'
    | '/evidence/$caseId'
    | '/intake/$caseId'
    | '/payment/$caseId'
    | '/post/$caseId'
    | '/processing/$caseId'
    | '/review/$caseId'
    | '/evidence'
    | '/intake'
    | '/payment'
    | '/post'
    | '/processing'
    | '/review'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/admin/aiops'
    | '/admin/control'
    | '/admin/infra'
    | '/evidence/$caseId'
    | '/intake/$caseId'
    | '/payment/$caseId'
    | '/post/$caseId'
    | '/processing/$caseId'
    | '/review/$caseId'
    | '/evidence/'
    | '/intake/'
    | '/payment/'
    | '/post/'
    | '/processing/'
    | '/review/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  AdminAiopsRoute: typeof AdminAiopsRoute
  AdminControlRoute: typeof AdminControlRoute
  AdminInfraRoute: typeof AdminInfraRoute
  EvidenceCaseIdRoute: typeof EvidenceCaseIdRoute
  IntakeCaseIdRoute: typeof IntakeCaseIdRoute
  PaymentCaseIdRoute: typeof PaymentCaseIdRoute
  PostCaseIdRoute: typeof PostCaseIdRoute
  ProcessingCaseIdRoute: typeof ProcessingCaseIdRoute
  ReviewCaseIdRoute: typeof ReviewCaseIdRoute
  EvidenceIndexRoute: typeof EvidenceIndexRoute
  IntakeIndexRoute: typeof IntakeIndexRoute
  PaymentIndexRoute: typeof PaymentIndexRoute
  PostIndexRoute: typeof PostIndexRoute
  ProcessingIndexRoute: typeof ProcessingIndexRoute
  ReviewIndexRoute: typeof ReviewIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/': {
      id: '/review/'
      path: '/review'
      fullPath: '/review/'
      preLoaderRoute: typeof ReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/processing/': {
      id: '/processing/'
      path: '/processing'
      fullPath: '/processing/'
      preLoaderRoute: typeof ProcessingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/': {
      id: '/post/'
      path: '/post'
      fullPath: '/post/'
      preLoaderRoute: typeof PostIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/': {
      id: '/payment/'
      path: '/payment'
      fullPath: '/payment/'
      preLoaderRoute: typeof PaymentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intake/': {
      id: '/intake/'
      path: '/intake'
      fullPath: '/intake/'
      preLoaderRoute: typeof IntakeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evidence/': {
      id: '/evidence/'
      path: '/evidence'
      fullPath: '/evidence/'
      preLoaderRoute: typeof EvidenceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$caseId': {
      id: '/review/$caseId'
      path: '/review/$caseId'
      fullPath: '/review/$caseId'
      preLoaderRoute: typeof ReviewCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/processing/$caseId': {
      id: '/processing/$caseId'
      path: '/processing/$caseId'
      fullPath: '/processing/$caseId'
      preLoaderRoute: typeof ProcessingCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/$caseId': {
      id: '/post/$caseId'
      path: '/post/$caseId'
      fullPath: '/post/$caseId'
      preLoaderRoute: typeof PostCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/$caseId': {
      id: '/payment/$caseId'
      path: '/payment/$caseId'
      fullPath: '/payment/$caseId'
      preLoaderRoute: typeof PaymentCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intake/$caseId': {
      id: '/intake/$caseId'
      path: '/intake/$caseId'
      fullPath: '/intake/$caseId'
      preLoaderRoute: typeof IntakeCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evidence/$caseId': {
      id: '/evidence/$caseId'
      path: '/evidence/$caseId'
      fullPath: '/evidence/$caseId'
      preLoaderRoute: typeof EvidenceCaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/infra': {
      id: '/admin/infra'
      path: '/admin/infra'
      fullPath: '/admin/infra'
      preLoaderRoute: typeof AdminInfraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/control': {
      id: '/admin/control'
      path: '/admin/control'
      fullPath: '/admin/control'
      preLoaderRoute: typeof AdminControlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/aiops': {
      id: '/admin/aiops'
      path: '/admin/aiops'
      fullPath: '/admin/aiops'
      preLoaderRoute: typeof AdminAiopsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  AdminAiopsRoute: AdminAiopsRoute,
  AdminControlRoute: AdminControlRoute,
  AdminInfraRoute: AdminInfraRoute,
  EvidenceCaseIdRoute: EvidenceCaseIdRoute,
  IntakeCaseIdRoute: IntakeCaseIdRoute,
  PaymentCaseIdRoute: PaymentCaseIdRoute,
  PostCaseIdRoute: PostCaseIdRoute,
  ProcessingCaseIdRoute: ProcessingCaseIdRoute,
  ReviewCaseIdRoute: ReviewCaseIdRoute,
  EvidenceIndexRoute: EvidenceIndexRoute,
  IntakeIndexRoute: IntakeIndexRoute,
  PaymentIndexRoute: PaymentIndexRoute,
  PostIndexRoute: PostIndexRoute,
  ProcessingIndexRoute: ProcessingIndexRoute,
  ReviewIndexRoute: ReviewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
